import type { Author } from '@flocasts/flosports30-types/dist/entity'
import { parseISO } from 'date-fns'

interface AuthorDate {
  firstName: string | null
  lastName: string | null
  date: Date | null
}

/**
 * This does not support dates created with toISOString (Safari date strings)
 * `2020-09-21T17:42:01.788Z` will return Date { NAN }
 * Use Date ISO string that the API returns
 */
export function buildAuthorDate(a: Author | null, d: string | null): AuthorDate {
  return {
    firstName: a?.first_name ? a.first_name : null,
    lastName: a?.last_name ? a.last_name : null,
    date: d !== null ? parseISO(d) : null
  }
}

export function buildAuthorLeadInText(a: Author | null, d: string | null): string {
  if (a && !d) {
    return 'Last Updated'
  }
  if (d) {
    return `Last Updated on`
  }
  return ''
}
